export * from './lista/vista-patentes-mineras-lista.component';
